module.exports = __webpack_public_path__ + "static/media/SYDummies25-1.826bbf97.png";